import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Kan jag få serveringstillstånd om jag har skatteskuld?";
const SHORT_ANSWER = "Mindre, betalplanslagda skulder kan accepteras. Stora obetalda skulder eller skattebrott leder normalt till avslag.";

export const Route = createFileRoute("/fraga/far-jag-tillstand-med-skatteskuld")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Kan jag få serveringstillstånd om jag har skatt…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Reglera skulder, gör upp betalningsplan med Skatteverket och dokumentera detta i ansökan. Vid stora belopp eller pågående indrivning är chansen liten oavsett bortförklaring."}
      source={{ label: "Skatteverket – Personlig och ekonomisk lämplighet", href: "https://www.skatteverket.se/" }}
      extraSources={[]}
      deepGuide={{ to: "/pbi-krets", label: "Lämplighetsprövning – skuld och vandel" }}
      related={[{"to": "/fraga/far-jag-tillstand-med-tidigare-domar", "label": "Får jag serveringstillstånd om jag har tidigare domar?"}, {"to": "/fraga/hur-lang-tid-tillbaka-tittar-kommunen", "label": "Hur långt tillbaka tittar kommunen vid lämplighetsprövning?"}, {"to": "/fraga/vad-ar-vandel", "label": "Vad menas med 'god vandel' i alkohollagen?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Kan jag få serveringstillstånd om jag har skatteskuld?" },
      { name: "description", content: "Mindre, betalplanslagda skulder kan accepteras. Stora obetalda skulder eller skattebrott leder normalt till avslag." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/far-jag-tillstand-med-skatteskuld" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/far-jag-tillstand-med-skatteskuld" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/far-jag-tillstand-med-skatteskuld",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Kan jag få serveringstillstånd om jag har skatt…", url: "https://alkoholprovet.se/fraga/far-jag-tillstand-med-skatteskuld" },
      ]),
    ],
  }),
});
